import React, { MouseEvent, useEffect, useState } from "react";
import AppBarManageMenuItems from "./AppBarManageMenuItems";
import ProfileMenu from "./ProfileMenu";
import useAppBarStyles, { AnchorLink, ListItem } from "./styles";
import useScreenSize from "../hooks/useScreenSize";
import { Collapse, Popover, ListGroup, NavbarToggler } from "reactstrap";
import { IsCauwUser, IsOrganizationDonor, IsOrganizationUser, getOrganizationName, getUserInitials, getOrganizationId } from "../../utility/helpers/claimHelper";
import useConfigApiClient from "../../app/apiClient/configApiClient";
import endPoints from "../../app/model/api/endPoints";
import CauwLogo from "../../assets/images/cauw-footer.png";
import SideBar from "../../pages/layouts/_SideBar";

const AppBar: React.FC<{ showSideNavigation?: boolean }> = ({ showSideNavigation }) => {
    const appBarStyles = useAppBarStyles();

    useConfigApiClient();

    const windowWidth = useScreenSize();

    const [open, setOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMenuPopover = () => setOpen(!open);
    const toggleMobileMenuPopover = () => setMobileMenuOpen(!mobileMenuOpen);

    const [openProfile, setOpenProfile] = useState(false);
    const toggleProfileMenuPopover = () => setOpenProfile(!openProfile);

    const [mobileMenuTargetElement, setMobileMenuTargetElement] = useState<HTMLDivElement | HTMLElement | null>(null);
    const [menuLinksTargetElement, setMenuLinksTargetElement] = useState<HTMLDivElement | HTMLElement | null>(null);
    const [profileLinkTargetElement, setProfileLinkTargetElement] = useState<HTMLElement | null>(null);

    const updateProfileLinkTargetElement = (event: MouseEvent<HTMLElement>) => {
        setProfileLinkTargetElement(event.currentTarget);
        toggleProfileMenuPopover();
    };

    const updateMobileMenuLinkTargetElement = (
        event: MouseEvent<HTMLElement>
    ) => {
        setMobileMenuTargetElement(
            event.currentTarget
                ? event.currentTarget
                : (event.target as HTMLDivElement)
        );
        toggleMobileMenuPopover();
    };

    useEffect(() => {
        setOpen(false);
        setMobileMenuOpen(false);
        setOpenProfile(false);
        setMenuLinksTargetElement(null);
        setMobileMenuTargetElement(null);
        setProfileLinkTargetElement(null);
    }, [windowWidth]);

    const userInitials = getUserInitials();
    const organizationId = getOrganizationId();
    const organizationLogo = organizationId.trim()
        ? endPoints.organization.getOrganizationLogo(organizationId)
        : CauwLogo;

    return (
        <>
            <div style={appBarStyles.menuButton}>
                {menuLinksTargetElement && (
                    <AppBarManageMenuItems
                        open={open}
                        toggleMenuPopover={toggleMenuPopover}
                        targetElementMenu={menuLinksTargetElement}
                    />
                )}
                {profileLinkTargetElement && (
                    <ProfileMenu
                        profileOpen={openProfile}
                        toggleProfileMenuPopover={toggleProfileMenuPopover}
                        targetElementMenu={profileLinkTargetElement}
                    />
                )}
            </div>

            {mobileMenuTargetElement && (
                <Popover
                    className="mobile-navigation-popover"
                    placement="bottom"
                    isOpen={mobileMenuOpen}
                    trigger={open ? "click" : "legacy"}
                    target={mobileMenuTargetElement}
                    toggle={toggleMobileMenuPopover}
                    hideArrow
                >
                    <ListGroup>
                        {showSideNavigation && (
                            <div className="mobile-side-nav">
                                <SideBar compact onNavigate={() => setMobileMenuOpen(false)} />
                            </div>
                        )}
                        <ListItem>
                            <AnchorLink
                                id="ProfileLink"
                                onClick={(e) => updateProfileLinkTargetElement(e)}
                            >
                                Profile{" "}
                            </AnchorLink>
                        </ListItem>
                    </ListGroup>
                </Popover>
            )}
            {
                <>
                    <NavbarToggler
                        className="mr-2"
                        onClick={(e) => updateMobileMenuLinkTargetElement(e)}
                    />
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" navbar>
                        <div className="flex">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
                                {(IsCauwUser() || IsOrganizationUser() || IsOrganizationDonor()) && (
                                    <li className="nav-item">
                                        {/*<span style={appBarStyles.headerItem} className="me-3 organization-header-text" >{getOrganizationName()}</span>*/}
                                        <img src={organizationLogo} alt="" className="img-fluid header-logo d-block p-1 me-3" />
                                    </li>
                                )}

                                <li className="nav-item">
                                    <div id="profileMenuPopover" style={appBarStyles.headerItem} className="py-1 px-2" onClick={(e) => updateProfileLinkTargetElement(e)} >
                                        <span style={appBarStyles.headerUser} className="header-text rounded-circle p-2" >
                                            {" "}
                                            {userInitials !== "" ? (
                                                <span style={appBarStyles.headerUserText}>
                                                    {userInitials}
                                                </span>
                                            ) : (
                                                <span className="bi bi-person-fill" style={appBarStyles.headerUserText} ></span>
                                            )}
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Collapse>
                </>
            }
        </>
    );
};

export default AppBar;
